export default "__VITE_ASSET__CDbOfJI0__"